import { FC } from 'react'
import Image from 'next/image'

import { Icon } from '~/src/components/generic/PhosphorIcons'

import colors from '~/config/colorsScheme'

type Props = {
  profilePictureUrl?: string | null
}

const UserProfileIcon: FC<Props> = ({ profilePictureUrl }) => {
  return (
    <div className="relative my-0.5 ml-0.5 flex h-8 w-8 items-center justify-center overflow-hidden rounded-full bg-gray-300 text-inverted">
      {profilePictureUrl ? (
        <Image alt="User profile picture" fill src={profilePictureUrl} />
      ) : (
        <Icon
          aria-label="User profile icon"
          color={colors.gray[500]}
          name="UserIcon"
          size="20"
        />
      )}
    </div>
  )
}

export default UserProfileIcon
